// @flow strict
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
// $FlowFixMe[nonstrict-import]
import type {DynamicLabelExtra} from 'src/action-creators/dynamic-labels';
// $FlowFixMe[nonstrict-import]
import type {SuggestionProps} from 'src/components/lib/token-list-input/new-stuff.jsx';

import {useSelector} from 'react-redux';
// $FlowFixMe[nonstrict-import]
import {
  // $FlowFixMe[nonstrict-import]
  entityColorMapping,
  // $FlowFixMe[nonstrict-import]
  getAttributeRelationshipPath,
  // $FlowFixMe[nonstrict-import]
  generateAttributeGrammarTokens,
} from 'src/utils/entities';

//$FlowFixMe[untyped-import]
import {classify} from 'src/utils';
// $FlowFixMe[nonstrict-import]
import {selectEntityTypeMappingsByName} from 'src/selectors/ats-entities';

import common from 'src/styles/common.css';
import css from 'src/components/lib/variable-picker/variable-picker.css';


export function NewVariableDropdownRow({
  className,
  option: dynamicLabel,
  onClick,
  isSelected,
}: SuggestionProps<DynamicLabelExtra>): React.Element<'div'> {
  const entitiesByName = useSelector(selectEntityTypeMappingsByName);
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  let children;
  const regex = /^(?=.*[,\n]).+$/s;

  if (!dynamicLabel.entity_type) {
    if (dynamicLabel.arbitrary) {
      children = regex.test(dynamicLabel.value)
        ? `${t('Create_as_single_value', 'Create as single value')} (${
            dynamicLabel.value
          })`
        : `${t('Create', 'Create')} ${dynamicLabel.value}`;
    } else if (dynamicLabel.multiArbitrary) {
      children = `${t('Split', 'Split')} ${dynamicLabel.value
        .trim()
        .split(/[\,\n]/)
        .filter((value) => value !== '')
        .map((value) => `<${value}>`)
        .join(' ')}`;
    } else {
      children = (
        <div className={css.variableName}>{`${
          dynamicLabel.label || dynamicLabel.value
        }`}</div>
      );
    }
  } else {
    const color =
      (dynamicLabel.display_entity_type &&
        common[entityColorMapping[dynamicLabel?.sense_name]?.text]) ||
      common.colorGray6;

    const entityRelationshipPath =
      dynamicLabel.entityRelationshipPath ??
      getAttributeRelationshipPath(
        dynamicLabel.label,
        dynamicLabel.entity_type,
        entitiesByName,
      );

    const tokens = generateAttributeGrammarTokens(entityRelationshipPath);
    children = (
      <>
        <div
          key={dynamicLabel.label}
          style={{
            color,
          }}
          className={css.variableName}
        >
          {`${entityRelationshipPath[0]}`}
        </div>

        <section className={css.dropdownPipeSeparator} role="presentation">
          |
        </section>
        {tokens.map((token, index) => (
          <div
            key={index} // eslint-disable-line react/no-array-index-key
            className={classify(css.dropdownPhraseElement, {
              [css.dropdownBoldPhraseElement]: index % 2 !== 0,
            })}
          >
            {token}
          </div>
        ))}
      </>
    );
  }

  return (
    <div
      className={classify(css.dropdownResult, {
        [css.dropdownResultHighlighted]: isSelected,
      })}
      onClick={onClick}
      data-qa-id="variable-picker-dropdown-row"
    >
      {children}
    </div>
  );
}
